import _classCallCheck from "/home/docb/git/random-music/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/docb/git/random-music/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/docb/git/random-music/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/docb/git/random-music/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/docb/git/random-music/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/docb/git/random-music/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Util } from '../Util.js';
import { Factory } from '../Factory.js';
import { Shape } from '../Shape.js';
import { getNumberValidator } from '../Validators.js';
import { _registerNode } from '../Global.js';
export var Image = /*#__PURE__*/function (_Shape) {
  _inherits(Image, _Shape);

  var _super = _createSuper(Image);

  function Image(attrs) {
    var _this;

    _classCallCheck(this, Image);

    _this = _super.call(this, attrs);

    _this.on('imageChange.konva', function () {
      _this._setImageLoad();
    });

    _this._setImageLoad();

    return _this;
  }

  _createClass(Image, [{
    key: "_setImageLoad",
    value: function _setImageLoad() {
      var _this2 = this;

      var image = this.image();

      if (image && image['addEventListener']) {
        image['addEventListener']('load', function () {
          _this2._requestDraw();
        });
      }
    }
  }, {
    key: "_useBufferCanvas",
    value: function _useBufferCanvas() {
      return _get(_getPrototypeOf(Image.prototype), "_useBufferCanvas", this).call(this, true);
    }
  }, {
    key: "_sceneFunc",
    value: function _sceneFunc(context) {
      var width = this.getWidth();
      var height = this.getHeight();
      var image = this.attrs.image;
      var params;

      if (image) {
        var cropWidth = this.attrs.cropWidth;
        var cropHeight = this.attrs.cropHeight;

        if (cropWidth && cropHeight) {
          params = [image, this.cropX(), this.cropY(), cropWidth, cropHeight, 0, 0, width, height];
        } else {
          params = [image, 0, 0, width, height];
        }
      }

      if (this.hasFill() || this.hasStroke()) {
        context.beginPath();
        context.rect(0, 0, width, height);
        context.closePath();
        context.fillStrokeShape(this);
      }

      if (image) {
        context.drawImage.apply(context, params);
      }
    }
  }, {
    key: "_hitFunc",
    value: function _hitFunc(context) {
      var width = this.width(),
          height = this.height();
      context.beginPath();
      context.rect(0, 0, width, height);
      context.closePath();
      context.fillStrokeShape(this);
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      var _a, _b;

      return (_a = this.attrs.width) !== null && _a !== void 0 ? _a : (_b = this.image()) === null || _b === void 0 ? void 0 : _b.width;
    }
  }, {
    key: "getHeight",
    value: function getHeight() {
      var _a, _b;

      return (_a = this.attrs.height) !== null && _a !== void 0 ? _a : (_b = this.image()) === null || _b === void 0 ? void 0 : _b.height;
    }
  }], [{
    key: "fromURL",
    value: function fromURL(url, callback) {
      var img = Util.createImageElement();

      img.onload = function () {
        var image = new Image({
          image: img
        });
        callback(image);
      };

      img.crossOrigin = 'Anonymous';
      img.src = url;
    }
  }]);

  return Image;
}(Shape);
Image.prototype.className = 'Image';

_registerNode(Image);

Factory.addGetterSetter(Image, 'image');
Factory.addComponentsGetterSetter(Image, 'crop', ['x', 'y', 'width', 'height']);
Factory.addGetterSetter(Image, 'cropX', 0, getNumberValidator());
Factory.addGetterSetter(Image, 'cropY', 0, getNumberValidator());
Factory.addGetterSetter(Image, 'cropWidth', 0, getNumberValidator());
Factory.addGetterSetter(Image, 'cropHeight', 0, getNumberValidator());